export const CustomColorTokens = {
  BRAND_ORANGE: "#EC7211",
  BRAND_ORANGE_HOVER: "#B1550C",
  BRAND_ORANGE_PRESSED: "#753908",
  BRAND_BLUE_DARK: "#232F3E",
  BRAND_BLUE_LIGHT: "#1AA5DE",
  BRAND_BLUE_LIGHT_ALT: "#299EFF",
  BRAND_BLUE_PRIMARY: "#077398",
  BRAND_BLACK: "#000000",
  BRAND_GREY: "#545B64",
  BRAND_DARK_GREY: "#5B5B5B",
  BRAND_LIGHT_GRAY: "#697576",
  BRAND_WHITE: "#FFFFFF",
  BRAND_WHITE_HOVER: "#FAFAFA",
  BRAND_WHITE_PRESSED: "#EAEDED",
  BRAND_RED_LIGHT: "#FDF4F1",
  BRAND_RED_ERROR_BACKGROUND: "#F9D5E2",
  BRAND_RED: "red",
  BRAND_RED_DARK: "#ce5137",
  BRAND_RED_ERROR: "#CC0C39",
  BRAND_SQUID_INK: "#232F3E",
  SKELETON_BLUE: "#1A98FF",
  REBA_EXCELLENT: "#B2E14E",
  REBA_OK: "#FAE44D",
  REBA_BAD: "#F2A23A",
  REBA_VERY_BAD: "#ED6846",
  REBA_WORST: "#9B2065",
  BRAND_OFF_WHITE: "#F5F5F5",
  BRAND_DEEP_DARK_GRAY: "#DDDDDD",
  BRAND_ICE_WHITE: "#D1E6F536",
  BRAND_GREEN: "#3CA620",
  BRAND_WHITE_LIGHT: "#C6C6C6",
  TRA_SCORE_CURSOR: "#3A3636",
};
